import isEmpty from 'lodash.isempty'

import {
  getCurrencyFromCountryCode,
  getMarketsFromMarketplace,
} from '@core/helpers/countries'
import { fetchMerchantData } from '@http/endpoints'

export const getMerchantMarket = (countryCode) => ({
  countryCode,
  currency: getCurrencyFromCountryCode(countryCode),
})

export default {
  namespaced: true,

  state() {
    return {
      activeMarkets: [],
      canOpenNewMarkets: false,
      company: null,
      countryOfOrigin: null,
      email: null,
      featureFlags: {},
      hasOnlyOneMarket: false,
      id: null,
      markets: [],
      needToSignNewCgu: false,
      shopLink: null,
      potentialMarkets: [],
      referenceMarket: null,
    }
  },

  getters: {
    activeMarkets: (state) => state.activeMarkets.map(getMerchantMarket),
    canOpenNewMarkets: ({ canOpenNewMarkets }) => canOpenNewMarkets,
    company: (state) => state.company,
    countryOfOrigin: (state) => state.countryOfOrigin,
    email: (state) => state.email,
    featureFlags: (state) => state.featureFlags,
    hasOnlyOneMarket: (state) => {
      // to get all markets, we need to add the amount of potentialMarkets and activeMarkets
      // for example, this is a way to share to the store a boolean that help us
      // know if we should display components related to markets
      return state.potentialMarkets.length + state.activeMarkets.length === 1
    },
    id: (state) => state.id,
    isOffline: ({ activeMarkets }) => isEmpty(activeMarkets),
    marketsOfMarketplace: (state, getters, rootState, rootGetters) =>
      getMarketsFromMarketplace(rootGetters['config/marketplace']).map(
        (market) => ({
          countryCode: market.country,
          currency: getCurrencyFromCountryCode(market.country),
        }),
      ),
    needToSignNewCgu: (state) => state.needToSignNewCgu,
    shopLink: (state) => state.shopLink,
    potentialMarkets: (state) => state.potentialMarkets.map(getMerchantMarket),
    referenceMarket: (state) =>
      state.referenceMarket ? getMerchantMarket(state.referenceMarket) : {},
  },

  mutations: {
    setPayload(
      state,
      {
        activeMarkets,
        canOpenNewMarkets,
        company,
        countryOfOrigin,
        email,
        featureFlags,
        id,
        needToSignNewCgu,
        potentialMarkets,
        referenceMarket,
        shopLink,
      },
    ) {
      state.activeMarkets = activeMarkets
      state.canOpenNewMarkets = canOpenNewMarkets
      state.countryOfOrigin = countryOfOrigin
      state.company = company
      state.email = email
      state.featureFlags = featureFlags
      state.id = id
      state.potentialMarkets = potentialMarkets
      state.referenceMarket = referenceMarket
      state.needToSignNewCgu = needToSignNewCgu
      state.shopLink = shopLink
    },
  },

  actions: {
    async fetch({ commit, dispatch }) {
      const { payload } = await dispatch(
        'http/request',
        { request: fetchMerchantData },
        { root: true },
      )

      commit('setPayload', payload)
    },
  },
}
